import { render, staticRenderFns } from "./mAboutView.vue?vue&type=template&id=53bc5d98&"
import script from "./mAboutView.vue?vue&type=script&lang=js&"
export * from "./mAboutView.vue?vue&type=script&lang=js&"
import style0 from "./mAboutView.vue?vue&type=style&index=0&id=53bc5d98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports